import React, { useEffect } from 'react';
import { Spinner } from '@sitebase/ui-kit';
import cx from 'classnames';
import { WilliamHillLogoIcon } from './icons';
import { EntryStep, VerifyIdentityStep, ErrorStep, SuccessStep, RejectedStep } from './steps';
import { StepNames } from './types';
import { useVerificationFlow } from './hooks/useVerificationFlow';
import './IrelandVerificationJourney.scss';
import './i18n';
export const IrelandVerificationJourney = () => {
    const { state, actions, isJumioMock } = useVerificationFlow();
    useEffect(() => {
        actions.fetchSummaryData(true);
    }, []);
    const renderStep = () => {
        switch (state.currentStep) {
            case StepNames.ENTRY:
                return React.createElement(EntryStep, { onStart: actions.goToVerification });
            case StepNames.VERIFY_IDENTITY:
                return React.createElement(VerifyIdentityStep, { userData: state.userData, onStartVerification: actions.startVerification });
            case StepNames.SUCCESS:
                return React.createElement(SuccessStep, null);
            case StepNames.PARTIAL_SUCCESS:
                return React.createElement(SuccessStep, { isWaitingForConfirmation: true });
            case StepNames.REJECTED:
                return React.createElement(RejectedStep, { userName: state.userData.firstName });
            case StepNames.ERROR:
                return React.createElement(ErrorStep, { onRetry: actions.reset });
            default:
                return null;
        }
    };
    return (React.createElement(React.Fragment, null, state.currentStep === StepNames.VERIFICATION_PROCESS ? (React.createElement("div", { className: cx('verification-iframe-container', {
            'verification-iframe-container--full-size': isJumioMock,
        }) },
        React.createElement("iframe", { title: "Verification Process", src: state.verificationData.redirectUrl, className: "verification-iframe" }))) : (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "container__header" },
            React.createElement("div", { className: "container__header__logo" },
                React.createElement(WilliamHillLogoIcon, { width: 116, height: 24 }))),
        state.isLoading ? (React.createElement("div", { className: "container__spinner" },
            React.createElement(Spinner, null))) : (renderStep())))));
};
//# sourceMappingURL=IrelandVerificationJourney.js.map